import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaGlobe, FaBars, FaTimes } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
import { useTranslation } from "react-i18next";
import "../i18n";

const Navbar = () => {
  const { t, i18n } = useTranslation(['common', 'navBar']);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeGroup, setActiveGroup] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const location = useLocation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "jp" : "en";
    i18n.changeLanguage(newLang);
    localStorage.setItem("i18nextLng", newLang); // persist
    window.location.reload(); // reload to apply changes everywhere
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const menuItems = [
    { name: t("navBar:parentMenu.home"), id: "home" },
    { name: t("navBar:parentMenu.aboutDecimic"), id: "about" },
    { name: t("navBar:parentMenu.industries"), id: "industries" },
    { name: t("navBar:parentMenu.solutions"), id: "solutions" },
    { name: t("navBar:parentMenu.contact"), id: "contact" },
  ];

  const aboutSub = {
    [t('navBar:aboutDecimicSub.companyOverview')]: [  // <-- Translate the "About" key
      {
        label: t("navBar:companyOverviewSub.companyProfile"),
        href: "/about/company-profile",
        onClick: () => handleAboutClick(t("navBar:companyOverviewSub.companyProfile"))
      },
      {
        label: t("common:presidentMessage"),
        href: "/about/message",
        onClick: () => handleAboutClick(t("common:presidentMessage"))
      },
      {
        label: t("common:corporatePhilosophy"),
        href: "/about/corporatephilosophy",
        onClick: () => handleAboutClick(t("common:corporatePhilosophy"))
      }
    ]
  };


  const industries = {
    [t('navBar:industriesSub.industrialAndInfrastructure')]: [
      {
        label: t('navBar:industrialAndInfrastructureSub.manufacturing'),
        href: "/industries",
        onClick: () => handleIndustryClick(t('navBar:industrialAndInfrastructureSub.manufacturing'))
      },
      // {
      //   label: t('navBar:industrialAndInfrastructureSub.constructionAndUrbanDevelopment'),
      //   href: "/industries",
      //   onClick: () => handleIndustryClick(t('navBar:industrialAndInfrastructureSub.constructionAndUrbanDevelopment'))
      // },
      // {
      //   label: t('navBar:industrialAndInfrastructureSub.energyAndSolar'),
      //   href: "/industries",
      //   onClick: () => handleIndustryClick(t('navBar:industrialAndInfrastructureSub.energyAndSolar'))
      // },
      {
        label: t('navBar:industrialAndInfrastructureSub.automotiveAndTransportation'),
        href: "/industries",
        onClick: () => handleIndustryClick(t('navBar:industrialAndInfrastructureSub.automotiveAndTransportation'))
      }
    ],
    // [t('navBar:industriesSub.lifeSciencesHealthcareAndAgriculture')]: [
    //   {
    //     label: t('navBar:lifeSciencesHealthcareAndAgricultureSub.biotechnology'),
    //     href: "/industries#biotechnology-overview"
    //   },
    //   {
    //     label: t('navBar:lifeSciencesHealthcareAndAgricultureSub.healthcareAndMedicalServices'),
    //     href: "/industries#healthcare-overview"
    //   },
    //   {
    //     label: t('navBar:lifeSciencesHealthcareAndAgricultureSub.agricultureAndFoodTechnology'),
    //     href: "/industries#agriculture-overview"
    //   }
    // ],
    [t('navBar:industriesSub.technologyAndDigitalInnovation')]: [
      // {
      //   label: t('navBar:technologyAndDigitalInnovationSub.computingAndSpaceTech'),
      //   href: "/industries#computing-space-overview"
      // },
      // {
      //   label: t('navBar:technologyAndDigitalInnovationSub.advancedRoboticsAndAutonomousSystems'),
      //   href: "/industries#robotics-overview"
      // },
      {
        label: t('navBar:technologyAndDigitalInnovationSub.emergingDigitalPlatformsAndBlockchain'),
        href: "/industries#blockchain-overview"
      }
      // {
      //   label: t('navBar:technologyAndDigitalInnovationSub.aiDrivenQuantumComputingSolutions'),
      //   href: "/industries#quantum-overview"
      // },
      // {
      //   label: t('navBar:technologyAndDigitalInnovationSub.dataCenterAndHighPerformanceComputing'),
      //   href: "/industries#data-center-overview"
      // }
    ],
    [t('navBar:industriesSub.businessServicesAndProfessionalSolutions')]: [
      {
        label: t('navBar:businessServicesAndProfessionalSolutionsSub.businessManagementAndCorporateSolutions'),
        href: "/industries#business-management-overview"
      },
      // {
      //   label: t('navBar:businessServicesAndProfessionalSolutionsSub.accountingAndFinance'),
      //   href: "/industries#finance-overview"
      // },
      {
        label: t('navBar:businessServicesAndProfessionalSolutionsSub.customAndPersonalizedSolutions'),
        href: "/industries#custom-solutions-overview"
      },
      {
        label: t('navBar:businessServicesAndProfessionalSolutionsSub.customerSupportAndServiceAutomation'),
        href: "/industries#customer-support-overview"
      }
    ],
    [t('navBar:industriesSub.consumerServicesMediaAndEducation')]: [
      {
        label: t('navBar:consumerServicesMediaAndEducationSub.educationAndELearning'),
        href: "/industries#education-overview"
      },
      {
        label: t('navBar:consumerServicesMediaAndEducationSub.retailAndECommerce'),
        href: "/industries#retail-overview"
      },
      {
        label: t('navBar:consumerServicesMediaAndEducationSub.telecommunicationsMediaAndEntertainment'),
        href: "/industries#media-overview"
      },
      {
        label: t('navBar:consumerServicesMediaAndEducationSub.hospitalityAndTourism'),
        href: "/industries#hospitality-overview"
      }
    ]
    // [t('navBar:industriesSub.publicSectorAndGovernance')]: [
    //   {
    //     label: t('navBar:publicSectorAndGovernanceSub.publicSectorAndSmartGovernance'),
    //     href: "/industries#public-sector-overview"
    //   }
    // ]
  };

  // const solutions = {
  //   [t('navBar:solutionsSub.advancedSoftwareSolutionsAndDigitalTransformation')]: [
  //     {
  //       label: t('navBar:advancedSoftwareSub.advancedComputingAndCloudEdgeTechnologies'),
  //       href: "/solutions#advanced-computing-overview",
  //       onClick: () => handleSolutionClick(t('navBar:advancedSoftwareSub.advancedComputingAndCloudEdgeTechnologies'))
  //     },
  //     {
  //       label: t('navBar:advancedSoftwareSub.artificialIntelligenceAndMachineLearning'),
  //       href: "/solutions#ai-ml-overview",
  //       onClick: () => handleSolutionClick(t('navBar:advancedSoftwareSub.artificialIntelligenceAndMachineLearning'))
  //     },
  //     {
  //       label: t('navBar:advancedSoftwareSub.cybersecurityAndDataPrivacy'),
  //       href: "/solutions#cybersecurity-overview",
  //       onClick: () => handleSolutionClick(t('navBar:advancedSoftwareSub.cybersecurityAndDataPrivacy'))
  //     },
  //     {
  //       label: t('navBar:advancedSoftwareSub.aiAgentsAndConversationalAi'),
  //       href: "/solutions#ai-agents-overview",
  //       onClick: () => handleSolutionClick(t('navBar:advancedSoftwareSub.aiAgentsAndConversationalAi'))
  //     },
  //     {
  //       label: t('navBar:advancedSoftwareSub.dataCentersAndCloudInfrastructure'),
  //       href: "/solutions#data-centers-overview",
  //       onClick: () => handleSolutionClick(t('navBar:advancedSoftwareSub.dataCentersAndCloudInfrastructure'))
  //     },
  //     {
  //       label: t('navBar:advancedSoftwareSub.aiWithQuantumComputing'),
  //       href: "/solutions#ai-quantum-overview",
  //       onClick: () => handleSolutionClick(t('navBar:advancedSoftwareSub.aiWithQuantumComputing'))
  //     }
  //   ],
  //   [t('navBar:solutionsSub.revolutionizingDigitalPresenceAndMetaverseExperiences')]: [
  //     {
  //       label: t('navBar:digitalPresenceSub.advancedWebsiteDevelopment'),
  //       href: "/solutions#website-dev-overview",
  //       onClick: () => handleSolutionClick(t('navBar:digitalPresenceSub.advancedWebsiteDevelopment'))
  //     },
  //     {
  //       label: t('navBar:digitalPresenceSub.metaverseAndImmersiveEnvironments'),
  //       href: "/solutions#metaverse-overview",
  //       onClick: () => handleSolutionClick(t('navBar:digitalPresenceSub.metaverseAndImmersiveEnvironments'))
  //     },
  //     {
  //       label: t('navBar:digitalPresenceSub.humanMachineInterfaces'),
  //       href: "/solutions#hmi-overview",
  //       onClick: () => handleSolutionClick(t('navBar:digitalPresenceSub.humanMachineInterfaces'))
  //     },
  //     {
  //       label: t('navBar:digitalPresenceSub.uxUiDesignAndHumanCenteredInterfaces'),
  //       href: "/solutions#ux-ui-overview",
  //       onClick: () => handleSolutionClick(t('navBar:digitalPresenceSub.uxUiDesignAndHumanCenteredInterfaces'))
  //     }
  //   ],
  //   [t('navBar:solutionsSub.empoweringBusinessesWithNextGenerationCorporateSolutions')]: [
  //     {
  //       label: t('navBar:corporateSolutionsSub.customizedWorkflowDevelopment'),
  //       href: "/solutions#workflow-overview",
  //       onClick: () => handleSolutionClick(t('navBar:corporateSolutionsSub.customizedWorkflowDevelopment'))
  //     },
  //     {
  //       label: t('navBar:corporateSolutionsSub.integratedCorporateSolutions'),
  //       href: "/solutions#corporate-overview",
  //       onClick: () => handleSolutionClick(t('navBar:corporateSolutionsSub.integratedCorporateSolutions'))
  //     },
  //     {
  //       label: t('navBar:corporateSolutionsSub.innovativeCommunicationAndNetworkingTechnologies'),
  //       href: "/solutions#communication-overview",
  //       onClick: () => handleSolutionClick(t('navBar:corporateSolutionsSub.innovativeCommunicationAndNetworkingTechnologies'))
  //     },
  //     {
  //       label: t('navBar:corporateSolutionsSub.aiPoweredCustomerSupportSystems'),
  //       href: "/solutions#ai-support-overview",
  //       onClick: () => handleSolutionClick(t('navBar:corporateSolutionsSub.aiPoweredCustomerSupportSystems'))
  //     }
  //   ],
  //   [t('navBar:solutionsSub.mergingTechnologyWithSocialImpact')]: [
  //     {
  //       label: t('navBar:socialImpactSub.smartCityAndIotInnovations'),
  //       href: "/solutions#smart-city-overview",
  //       onClick: () => handleSolutionClick(t('navBar:socialImpactSub.smartCityAndIotInnovations'))
  //     },
  //     {
  //       label: t('navBar:socialImpactSub.inclusiveDigitalTransformation'),
  //       href: "/solutions#inclusive-dt-overview",
  //       onClick: () => handleSolutionClick(t('navBar:socialImpactSub.inclusiveDigitalTransformation'))
  //     },
  //     {
  //       label: t('navBar:socialImpactSub.ecoFriendlyAndCleanEnergyDataSolutions'),
  //       href: "/solutions#eco-friendly-overview",
  //       onClick: () => handleSolutionClick(t('navBar:socialImpactSub.ecoFriendlyAndCleanEnergyDataSolutions'))
  //     }
  //   ],
  //   [t('navBar:solutionsSub.futureVisionDrivingBreakthroughsAndDisruptiveInnovation')]: [
  //     {
  //       label: t('navBar:futureVisionSub.quantumComputingAndBeyond'),
  //       href: "/solutions#quantum-overview",
  //       onClick: () => handleSolutionClick(t('navBar:futureVisionSub.quantumComputingAndBeyond'))
  //     },
  //     {
  //       label: t('navBar:futureVisionSub.blockchainAndDigitalIdentity'),
  //       href: "/solutions#blockchain-overview",
  //       onClick: () => handleSolutionClick(t('navBar:futureVisionSub.blockchainAndDigitalIdentity'))
  //     },
  //     {
  //       label: t('navBar:futureVisionSub.automationAndRobotics'),
  //       href: "/solutions#automation-overview",
  //       onClick: () => handleSolutionClick(t('navBar:futureVisionSub.automationAndRobotics'))
  //     },
  //     {
  //       label: t('navBar:futureVisionSub.autonomousVehiclesAndAiAssistedMobility'),
  //       href: "/solutions#autonomous-overview",
  //       onClick: () => handleSolutionClick(t('navBar:futureVisionSub.autonomousVehiclesAndAiAssistedMobility'))
  //     }
  //   ]
  // };

  const handleAboutClick = (aboutName) => {
    sessionStorage.setItem('selectedAbout', aboutName);
  };

  const handleIndustryClick = (industryName) => {
    sessionStorage.setItem('selectedIndustry', industryName);
  };

  // const handleSolutionClick = (solutionName) => {
  //   sessionStorage.setItem('selectedSolution', solutionName);
  // };

  return (
    <nav className="fixed top-0 left-0 w-full bg-white text-black px-4 py-3 flex justify-between items-center z-50 shadow-md shadow-gray-300">
      <a href="/">
        <motion.img
          src={logo}
          alt="Logo"
          className="h-10 w-auto cursor-pointer"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          whileHover={{ scale: 1.1 }}
        />
      </a>

      {/* Hamburger icon for sm and md */}
      <div className="lg:hidden block">
        <button onClick={toggleMenu} className="text-2xl">
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Full menu for large screens */}
      <div className="hidden lg:flex lg:space-x-6 text-sm md:text-base lg:text-lg relative">
        {menuItems.map((item, i) => (
          // item.id === "industries" || item.id === "solutions" || item.id === "about" ? (
          item.id === "industries" || item.id === "about" ? (
            <motion.div
              key={i}
              className="relative group"
              onMouseEnter={() => setActiveMenu(item.id)} // Set active menu on hover
              onMouseLeave={() => setActiveMenu(null)} // Clear active menu when hover ends
            >
              <span className={`cursor-pointer hover:text-blue-600 transition duration-300  ${location.pathname.startsWith(`/${item.id}`) ? "text-blue-600 font-semibold" : ""
                }`}
              >
                {item.name}
              </span>
              <AnimatePresence>
                <motion.div
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  className="fixed left-1/2 transform -translate-x-1/2 bg-white rounded-b-xl shadow-xl p-6 w-[800px] flex z-40 hidden group-hover:flex"
                >
                  <div className="w-1/2 border-r border-gray-200 pr-6">
                    {Object.keys(
                      item.id === "industries"
                        ? industries
                        // : item.id === "solutions"
                        //   ? solutions
                          : item.id === "about"
                            ? aboutSub
                            : {}
                    ).map((group, idx) => (
                      <div
                        key={idx}
                        className="group/item cursor-pointer py-2 hover:bg-gray-50 px-3 rounded"
                        onMouseEnter={() => setActiveGroup(group)}
                      >
                        <span className="text-gray-800">{group}</span>
                      </div>
                    ))}

                  </div>
                  <div className="w-1/2 pl-6">
                    {activeGroup && (
                      (item.id === "about" ? aboutSub
                        : item.id === "industries" ? industries
                          // : item.id === "solutions" ? solutions
                            : null
                      )?.[activeGroup]?.map((subItem, idx) => (
                        <a
                          key={idx}
                          href={subItem.href}
                          onClick={(e) => {
                            e.preventDefault();
                            if (item.id === "about") {
                              handleIndustryClick(subItem.label);
                            } 
                            // else if (item.id === "solutions") {
                            //   // handleSolutionClick(subItem.label);
                            // } 
                            else if (item.id === "industries") {
                              handleAboutClick(subItem.label); // Make sure you define this handler
                            }
                            setActiveMenu(null); // Close submenu after click
                            window.location.href = subItem.href;
                          }}
                          className="block py-2 text-gray-700 hover:text-blue-600"
                        >
                          {subItem.label}
                        </a>
                      ))
                    )}

                  </div>
                </motion.div>
              </AnimatePresence>
            </motion.div>
          ) : (
            <motion.div key={i} whileHover={{ scale: 1.05 }}>
              <a
                href={`/${item.id}`}
                className={`hover:text-blue-600 transition duration-300 ${location.pathname.startsWith(`/${item.id}`) ? "text-blue-600 font-semibold" : ""
                  }`}
              >
                {item.name}
              </a>
            </motion.div>
          )
        ))}
      </div>


      {/* Mobile Menu Dropdown */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full left-0 w-full bg-white shadow-lg py-6 px-6 text-base flex flex-col space-y-6 lg:hidden max-h-[80vh] overflow-y-auto"
          >
            {menuItems.map((item, i) => {
              // const hasSubmenu = ["industries", "solutions", "about"].includes(item.id);
              const hasSubmenu = ["industries", "about"].includes(item.id);
              const isExpanded = expandedMenu === item.id;

              return (
                <div key={i}>
                  {hasSubmenu ? (
                    <button
                      onClick={() =>
                        hasSubmenu
                          ? setExpandedMenu(isExpanded ? null : item.id)
                          : setIsMenuOpen(false)
                      }
                      className="hover:text-blue-600 block font-semibold mb-1 text-left w-full"
                    >
                      {item.name}
                    </button>
                  ) : (
                    <a
                      href={`/${item.id}`}
                      // onClick={() => setIsMenuOpen(false)}
                      className="hover:text-blue-600 block font-semibold mb-1 text-left w-full"
                    >
                      {item.name}
                    </a>
                  )}

                  {hasSubmenu && isExpanded && (
                    <div className="grid grid-cols-2 gap-4 pl-2 border-l border-gray-200">
                      {Object.keys(
                        item.id === "industries"
                          ? industries
                          // : item.id === "solutions"
                          //   ? solutions
                            : aboutSub
                      ).map((group, idx) => (
                        <div key={idx} className="space-y-2">
                          <span className="text-gray-800 font-medium block">{group}</span>
                          <div className="flex flex-col space-y-1">
                            {(item.id === "industries"
                              ? industries
                              // : item.id === "solutions"
                              //   ? solutions
                                : aboutSub)[group].map((subItem, subIdx) => (
                                  <a
                                    key={subIdx}
                                    href={subItem.href}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (item.id === "industries") {
                                        handleIndustryClick(subItem.label);
                                      } 
                                      // else if (item.id === "solutions") {
                                      //   handleSolutionClick(subItem.label);
                                      // }
                                       else {
                                        handleAboutClick(subItem.label);
                                      }
                                      setIsMenuOpen(false);
                                      window.location.href = subItem.href;
                                    }}
                                    className="text-gray-700 hover:text-blue-600 text-sm"
                                  >
                                    {subItem.label}
                                  </a>
                                ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </motion.div>
        )}

      </AnimatePresence>


      <button
        onClick={toggleLanguage}
        className="ml-4 flex items-center justify-center space-x-2 w-24 sm:w-28 md:w-32 px-3 md:px-4 py-2 rounded-full text-white bg-gray-500 hover:bg-gray-900 shadow-gray-900 transition duration-300 text-xs sm:text-sm md:text-base"
      >
        <FaGlobe className="text-base sm:text-lg md:text-xl" />
        <span className="w-full text-center">
          {i18n.language === "en" ? "日本語" : "English"}
        </span>
      </button>
    </nav>
  );
};

export default Navbar;
